import React, { useEffect, useMemo, useState } from "react";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";
import icon1 from "../../../../assets/images/icon1.png";
import icon2 from "../../../../assets/images/icon2.png";
import { getAssetStatusSummary } from "../../../Apis/DashboardApis/primaryDashboardApi";
import CardLoader from "../../../Common/ShimmerLoader/CardLoader";
import DashboardSectionCard from "./shared/DashboardSectionCard";
import MetricStat from "./shared/MetricStat";

const formatCount = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  return Number(value).toLocaleString();
};

const buildStats = (summary) => [
  {
    iconSrc: icon1,
    label: "Total Assets",
    value: formatCount(summary?.totalAssets),
    color: "#2563eb",
  },
  {
    iconSrc: icon2,
    label: "Active",
    value: formatCount(summary?.activeAssets),
    color: "#16a34a",
  },
  {
    icon: faPowerOff,
    label: "Inactive",
    value: formatCount(summary?.inActiveAssets),
    color: "#dc2626",
  },
];

const AssetStatusSummary = ({ data }) => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(!data);

  useEffect(() => {
    if (data) {
      return undefined;
    }

    let isMounted = true;

    const fetchSummary = async () => {
      try {
        setLoading(true);
        const response = await getAssetStatusSummary();

        if (isMounted && response?.status && response?.data) {
          setSummary(response.data);
        }
      } catch (error) {
        console.error("Failed to load asset status summary:", error);
        if (isMounted) {
          setSummary(null);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchSummary();

    return () => {
      isMounted = false;
    };
  }, [data]);

  const stats = useMemo(() => {
    if (Array.isArray(data)) {
      return data;
    }

    return buildStats(summary);
  }, [data, summary]);

  return (
    <DashboardSectionCard title="Asset Status Summary">
      {loading ? (
        <CardLoader count={3} />
      ) : (
        <div className="pd-metric-row cols-3 pd-asset-row">
          {stats.map((item) => (
            <MetricStat key={item.label} {...item} horizontal />
          ))}
        </div>
      )}
    </DashboardSectionCard>
  );
};

export default AssetStatusSummary;
